var _this = this;
import moment from 'moment';
import clone from 'ramda/src/clone';
import { SCHEDULED_ORDER_OPTIONS } from '../../../../../../customercare.constants';
var defaultExecutionOptions = {
  effective: "".concat(SCHEDULED_ORDER_OPTIONS.EFFECTIVE_IMMEDIATELY)
};
var getExecutionDate = function getExecutionDate(executionOptionsModel) {
  switch (executionOptionsModel.effective) {
    case "".concat(SCHEDULED_ORDER_OPTIONS.EFFECTIVE_IMMEDIATELY):
      return null;
    case "".concat(SCHEDULED_ORDER_OPTIONS.ON_NEXT_BILL_CYCLE):
      return moment(_this.billCycleDate).toISOString();
    case "".concat(SCHEDULED_ORDER_OPTIONS.ON_SPECIFIED_DATE):
      return executionOptionsModel.specifiedDateFromPicker;
    default:
      return null;
  }
};
export var getInitialExecutionOptionsModel = function getInitialExecutionOptionsModel(_ref) {
  var executionOptionsSavedCopy = _ref.executionOptionsSavedCopy,
    showImmediateOption = _ref.showImmediateOption,
    showBillCycleOption = _ref.showBillCycleOption,
    showDatePickerOption = _ref.showDatePickerOption,
    isBillingEffectiveDateShown = _ref.isBillingEffectiveDateShown,
    billingEffectiveDateOptions = _ref.billingEffectiveDateOptions;
  var executionOptionsModel = {};
  executionOptionsModel = executionOptionsSavedCopy && executionOptionsSavedCopy.effective ? clone(executionOptionsSavedCopy) : defaultExecutionOptions;
  if (!showImmediateOption && showBillCycleOption && !executionOptionsSavedCopy.effective) {
    executionOptionsModel.effective = "".concat(SCHEDULED_ORDER_OPTIONS.ON_NEXT_BILL_CYCLE);
  }
  if (!showImmediateOption && !showBillCycleOption && showDatePickerOption) {
    executionOptionsModel.effective = "".concat(SCHEDULED_ORDER_OPTIONS.ON_SPECIFIED_DATE);
  }
  executionOptionsModel.specifiedDate = executionOptionsSavedCopy && executionOptionsSavedCopy.specifiedDate || getExecutionDate(executionOptionsModel);
  executionOptionsModel.applyBalanceToInvoice = true;
  if (isBillingEffectiveDateShown && billingEffectiveDateOptions && billingEffectiveDateOptions.length) {
    var filteredBillingEffectiveDateOptions = {};
    var savedBillingEffectiveIntention = +executionOptionsModel.billingEffectiveIntention;
    billingEffectiveDateOptions.forEach(function (option) {
      if (option.Valid) {
        var isDisabled = option.OrderExecutionDateIntention !== +executionOptionsModel.effective;
        var isShown = !isDisabled || !filteredBillingEffectiveDateOptions[option.BillingEffectiveDateIntention];
        var isSelected = !isDisabled && savedBillingEffectiveIntention === option.BillingEffectiveDateIntention;
        if (isShown) {
          filteredBillingEffectiveDateOptions[option.BillingEffectiveDateIntention] = Object.assign({}, option, {
            isDisabled: isDisabled,
            isSelected: isSelected
          });
        }
        if (option.Default) {
          executionOptionsModel.billingEffectiveIntention = "".concat(option.BillingEffectiveDateIntention);
        }
      }
    });
    if (filteredBillingEffectiveDateOptions[savedBillingEffectiveIntention] && !filteredBillingEffectiveDateOptions[savedBillingEffectiveIntention].isDisabled) {
      executionOptionsModel.billingEffectiveIntention = "".concat(savedBillingEffectiveIntention);
    }
  }
  return executionOptionsModel;
};